export enum CampaignControlOptionApiGroup {
  Google = 'Google',
  Beeswax = 'Omnichannel',
}
